import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    voterId: "",
    mobile: "",
    place: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const onlyNums = value.replace(/\D/g, "").slice(0, 10);
      setForm({ ...form, mobile: onlyNums });
      return;
    }

    setForm({ ...form, [name]: value });
  };

 const handleRegister = async (e) => {
  e.preventDefault();

  if (!form.name || !form.voterId || !form.mobile || !form.place) {
    toast.error("அனைத்து புலங்களையும் நிரப்பவும் ❌");
    return;
  }

  if (form.mobile.length !== 10) {
    toast.error("சரியான மொபைல் எண் உள்ளிடவும் ❌");
    return;
  }

  try {
    setLoading(true);

    // CHECK DUPLICATE
   // CHECK DUPLICATE (VOTER + MOBILE)
const checkRes = await fetch(
    "https://tvk-backend-yl1b.onrender.com/api/check-user",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        voterId: form.voterId,
        mobile: form.mobile
      }),
    }
  );

  const checkData = await checkRes.json();

  if (checkData.voterExists) {
    toast.error("இந்த Voter ID ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது ❌");
    setLoading(false);
    return;
  }

  if (checkData.mobileExists) {
    toast.error("இந்த மொபைல் எண் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது ❌");
    setLoading(false);
    return;
  }


    // REGISTER
    const res = await fetch(
      "https://tvk-backend-yl1b.onrender.com/api/register",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("வெற்றிகரமாக பதிவு செய்யப்பட்டது ✅");

      // ✅ SAVE DIFFERENT KEY
      localStorage.setItem("profileUser", JSON.stringify(form));
      localStorage.setItem("profileLoggedIn", "true");

      navigate("/profile");

    } else {
      toast.error("பதிவு தோல்வி ❌");
    }

  } catch (err) {
    toast.error("Server error ❌");
  }

  setLoading(false);
};

useEffect(() => {
  // If already profile user
  if (localStorage.getItem("profileLoggedIn")) {
    navigate("/profile");
  
  }
}, [navigate]);


  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleRegister}>
        <h3 style={{ textAlign: "center", color: "#8B0000" }}>
          கழகத்தில் இணைய
        </h3>

        <input
          type="text"
          name="name"
          placeholder="பெயர்"
          value={form.name}
          onChange={handleChange}
        />

        <input
          type="text"
          name="voterId"
          placeholder="Voter ID"
          value={form.voterId}
          onChange={handleChange}
        />

        <input
          type="tel"
          name="mobile"
          placeholder="மொபைல் எண்"
          value={form.mobile}
          onChange={handleChange}
        />

        <input
          type="text"
          name="place"
          placeholder="ஊர் / பகுதி"
          value={form.place}
          onChange={handleChange}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Registering..." : "பதிவு செய்ய"}
        </button>
      </form>
    </div>
  );
}

export default Register;
